import React, { Component } from 'react';
import IconMenus from '../UI/IconMenu';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import logo from '../../assets/img/logo.svg';

class Toolbar extends Component {

    render () {
        return (
            <header className="flex align-center justify-between">
                <div className="logo">
                    <Link to="">
                        <img src={ logo } alt="logo"/>
                    </Link>
                </div>
                <div className="right-options flex-center-y">
                    <p className="name px-20">{ this.props.adminName || localStorage.getItem('adminName') }</p>
                    <div className="px-20">
                        <IconMenus />
                    </div>
                    <Link to="" className="no-style notify active mx-20">
                        <i className="fa fa-bell"></i>
                    </Link>
                    <Link to="/logout" className="pl-20">
                        <i className="fa fa-sign-out"></i>
                    </Link>
                </div>
            </header>
        )
    }
}

const mapStateToProps = state => {
    return {
        adminName: state.auth.adminName
    }
};

export default connect(mapStateToProps)( Toolbar );


// WEBPACK FOOTER //
// ./src/components/Toolbar/Toolbar.js